import React, { useEffect, useState } from 'react';
import { Card, Badge, Spinner } from 'react-bootstrap';

const ListaEquipamentos = (props) => {

  const {
    masters,
    selectedMaster,
    onMasterSelect
  } = props;

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [masters]);

  const handleMasterClick = (master) => {
    onMasterSelect(master);
  };

  const renderMaster = (master) => {
    const isActive = selectedMaster?._id === master._id;
    const masterName = master.nameEquipment || master.serialnumber;
    const slavesCount = master.slaves?.length || 0;
    const tAmb = master?.tAmb ?? master?.config?.tAmb ?? null;
    const hasTAmb = typeof tAmb === 'number' && tAmb !== -88;

    return (
      <Card
        key={master._id}
        className={`${isActive ? 'company-list-item active' : 'company-list-item'}`}
        onClick={() => handleMasterClick(master)}
        style={{
          cursor: "pointer",
          marginBottom: '12px',
          background: isActive ? 'rgba(40, 167, 69, 0.85)' : 'rgba(52, 58, 64, 0.9)',
          border: `2px solid ${isActive ? '#28a745' : 'rgba(255, 255, 255, 0.2)'}`,
          borderRadius: '8px',
          transition: 'all 0.2s ease',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <Card.Body className='p-3'>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div style={{ flex: 1 }}>
              <Card.Title style={{
                fontSize: "1rem",
                fontWeight: "700",
                color: 'white',
                marginBottom: '4px'
              }}>
                {masterName.length > 25 ? masterName.slice(0, 25) + '...' : masterName}
              </Card.Title>
              <div style={{
                fontSize: "0.85rem",
                fontWeight: "600",
                color: 'rgba(255, 255, 255, 0.9)',
                marginBottom: '8px'
              }}>
                📡 {master.serialnumber}
              </div>
              <div className="d-flex flex-wrap align-items-center gap-2">
                <Badge 
                  bg="info" 
                  style={{
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    padding: '4px 8px'
                  }}
                >
                  {slavesCount} slave{slavesCount !== 1 ? 's' : ''}
                </Badge>
                <Badge
                  bg="secondary"
                  style={{
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    padding: '4px 8px'
                  }}
                >
                  🌡️ {hasTAmb ? `${tAmb.toFixed(1)}°C` : 'Sem dados'}
                </Badge>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  };

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Spinner animation="border" variant="primary" />
        <p style={{ color: 'var(--text-secondary)' }}>Atualizando...</p>
      </div>
    );
  }

  return (
    <div className="sensors-list-container">
      {/* Header da lista */}
      <div className="sensors-list-header">
        <Card style={{
          background: 'rgba(52, 58, 64, 0.9)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '8px'
        }}>
          <Card.Body className="p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-1" style={{ color: 'white', fontWeight: '600' }}>
                  📡 Masters
                </h6>
                <small style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  {masters.length} master{masters.length !== 1 ? 's' : ''} encontrado{masters.length !== 1 ? 's' : ''}
                </small>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>

      {/* Lista de masters com scroll interno */}
      <div className="sensors-list-content scrollbar">
        {isLoading ? (
          <div className="text-center p-4">
            <Spinner animation="border" style={{ color: 'white' }} />
            <div style={{ marginTop: '12px', color: 'white' }}>
              Carregando masters...
            </div>
          </div>
        ) : masters.length > 0 ? (
          masters.map((master) => renderMaster(master))
        ) : (
          <Card className="text-center p-4" style={{
            background: 'rgba(52, 58, 64, 0.9)',
            borderRadius: '8px',
            border: '2px dashed rgba(255, 255, 255, 0.3)'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📡</div>
            <h6 style={{ color: 'white' }}>Nenhum master encontrado</h6>
            <small style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
              Nenhum master cadastrado para esta empresa
            </small>
          </Card>
        )}
      </div>
    </div>
  );
};

export default ListaEquipamentos;
